"use client";

import Field from "../Field";
import InternationalPhoneInput from "./index";

interface InternationalPhoneProps {
  className?: string;
  errorFormatMessage: string;
  errorMessage?: string;
  fieldName: string;
  initialCountry?: string;
  inputClassName?: string;
  label: string;
  onBlur?: () => void;
  requiredPlaceholder?: string;
}

/**
 * International phone field component with built-in Field wrapper.
 * Drop-in replacement for the Phone component with international support.
 *
 * Uses intl-tel-input for country code selection and phone validation.
 */
function InternationalPhone({
  className,
  errorFormatMessage,
  errorMessage,
  fieldName,
  initialCountry = "us",
  inputClassName,
  label,
  onBlur,
  requiredPlaceholder,
}: InternationalPhoneProps) {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, fieldOnBlur) => (
        <InternationalPhoneInput
          className={inputClassName ?? "w-64"}
          inError={inError}
          initialCountry={initialCountry}
          onBlur={() => {
            fieldOnBlur();
            onBlur?.();
          }}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: (value) => {
          if (!value) return true;
          // intl-tel-input returns E.164 format, so check for + and minimum digits
          const digits = String(value).replace(/\D/g, "");
          return digits.length >= 8 || errorFormatMessage;
        },
      }}
      label={label}
      onBlur={onBlur}
      validateOnChange={true}
    />
  );
}

export default InternationalPhone;
